export default "__VITE_ASSET__a41d16fc__"